// Fotos de trabajos que llegan de Cyclone (galería y servicios). Cyclone guarda el original (hasta
// 1800×2400, 700 KB) y al subir cada imagen genera variantes: `_250.webp` y `_500.webp` cuadradas
// (recorte al centro) y `_1000.webp` entera, solo para galería. Pedir la variante justa es lo que
// mantiene liviana una grilla de 50 fotos; si una foto vieja no la tiene, <Photo> vuelve al original.

const AGORA_CDN = /^https:\/\/d3p2i4pt6coq3o\.cloudfront\.net\//;

const PHOTO_SIZES = [250, 500, 1000];

/** URL de la variante `size` de una foto de Ágora; cualquier otra URL vuelve tal cual. */
export function photoVariant(url, size = 500) {
  if (!url || typeof url !== 'string') return null;
  if (!AGORA_CDN.test(url) || url.includes('/defaults/') || /\.(webp|svg|gif)(\?|$)/i.test(url)) return url;
  if (!PHOTO_SIZES.includes(size)) return url;
  return `${url}_${size}.webp`;
}

/** Imagen por defecto de Ágora (avatar o portada sin cargar): no cuenta como foto del negocio. */
export const isDefaultImage = (url) => !url || String(url).includes('/defaults/');
